import React, { useEffect, useRef, useState } from 'react';
import i18next from 'i18next';
import {
  FloatingBtn,
  MenuContainer,
  MenuItem,
  FlagIcon,
  Arrow,
} from './LanguageButtonElements';

import brFlag from '../../images/br.png';
import usFlag from '../../images/us.png';
import esFlag from '../../images/es.png';

const LANGS = [
  { code: 'pt', label: 'Português', flag: brFlag },
  { code: 'en', label: 'English',   flag: usFlag },
  { code: 'es', label: 'Español',   flag: esFlag },
];

export default function LanguageButton() {
  const btnRef = useRef(null);
  const menuRef = useRef(null);
  const closeTimerRef = useRef(null);

  const [open, setOpen] = useState(false);      // estado visual do botão (seta/estilo)
  const [show, setShow] = useState(false);      // controla render do menu
  const [isClosing, setIsClosing] = useState(false); // animação de fechamento

  const currentCode = (i18next?.language || 'pt').slice(0, 2);
  const currentLang = LANGS.find(l => l.code === currentCode) ?? LANGS[0];

  const openMenu = () => {
    clearTimeout(closeTimerRef.current);
    setShow(true);
    setIsClosing(false);
    setOpen(true);
  };

  const closeMenu = () => {
    if (!show) return;
    setIsClosing(true);
    setOpen(false);
    clearTimeout(closeTimerRef.current);
    closeTimerRef.current = setTimeout(() => {
      setShow(false);
      setIsClosing(false);
    }, 300); // mesmo tempo do animation no styled
  };

  const toggle = () => (show ? closeMenu() : openMenu());

  useEffect(() => {
    if (!show) return;

    const onPointer = (e) => {
      const t = e.target;
      const outside =
        menuRef.current && !menuRef.current.contains(t) &&
        btnRef.current && !btnRef.current.contains(t);
      if (outside) closeMenu();
    };

    const onKey = (e) => {
      if (e.key === 'Escape') closeMenu();
    };

    document.addEventListener('mousedown', onPointer, true);
    document.addEventListener('touchstart', onPointer, true);
    document.addEventListener('keydown', onKey);

    return () => {
      document.removeEventListener('mousedown', onPointer, true);
      document.removeEventListener('touchstart', onPointer, true);
      document.removeEventListener('keydown', onKey);
    };
  }, [show]);

  useEffect(() => () => clearTimeout(closeTimerRef.current), []);

  const setLang = (code) => {
    try { i18next.changeLanguage(code); } catch {}
    closeMenu();
  };

  return (
    <>
      <FloatingBtn
        ref={btnRef}
        isOpen={open}
        aria-haspopup="menu"
        aria-expanded={show}
        onClick={toggle}
      >
        <FlagIcon src={currentLang.flag} alt={currentLang.code} />
        {currentLang.label}
        <Arrow isOpen={open}>▾</Arrow>
      </FloatingBtn>

      {show && (
        <MenuContainer ref={menuRef} role="menu" isClosing={isClosing}>
          {LANGS.map(lang => (
            <MenuItem
              key={lang.code}
              role="menuitem"
              isActive={lang.code === currentCode}
              onClick={() => setLang(lang.code)}
            >
              <FlagIcon src={lang.flag} alt={lang.code} />
              {lang.label}
            </MenuItem>
          ))}
        </MenuContainer>
      )}
    </>
  );
}